import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { VerticalAlignment } from '@freelancer/ui/grid';
import { HeadingType } from '@freelancer/ui/heading';
import { Margin } from '@freelancer/ui/margin';
import { FontWeight, TextSize } from '@freelancer/ui/text';
import { isDefined } from '@freelancer/utils';
import * as Rx from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-project-local-question',
  template: `
    <fl-heading
      i18n="Post Job Page form location question field label"
      [headingType]="HeadingType.H3"
      [flMarginBottom]="Margin.XXXSMALL"
      [size]="TextSize.MID"
    >
      Does this project need to be done in a specific location?
    </fl-heading>
    <fl-bit [flMarginBottom]="Margin.XLARGE">
      <fl-grid [vAlign]="VerticalAlignment.VERTICAL_STRETCH">
        <fl-col
          [col]="12"
          [colTablet]="6"
          [flMarginBottom]="Margin.SMALL"
          [flMarginBottomTablet]="Margin.NONE"
        >
          <fl-radio-card
            data-test-target="onlineJobCard"
            flTrackingLabel="NonLocal"
            i18n-pictureAlt="Online job icon alt text"
            pictureAlt="Online job icon"
            pictureSrc="job-post/post-project-online.svg"
            [control]="control"
            [isSelected]="isOnlineCardSelected$ | async"
            [value]="false"
            (click)="cardSelected.emit(false)"
          >
            <fl-radio-card-body>
              <fl-text
                i18n="
                   Post Job Page form location question - non-local job option
                  title
                "
                [size]="TextSize.SMALL"
                [weight]="FontWeight.BOLD"
              >
                No, online job
              </fl-text>

              <fl-text
                i18n="
                   Post Job Page form location question - non-local job option
                  description
                "
              >
                Your project can be completed from anywhere around the world.
                Expect more competitive bids.
              </fl-text>
            </fl-radio-card-body>
          </fl-radio-card>
        </fl-col>
        <fl-col [col]="12" [colTablet]="6">
          <fl-radio-card
            data-test-target="localJobCard"
            flTrackingLabel="Local"
            i18n-pictureAlt="Local job icon alt text"
            pictureSrc="job-post/post-project-local.svg"
            pictureAlt="Local job icon"
            [control]="control"
            [isSelected]="isLocalCardSelected$ | async"
            [value]="true"
            (click)="cardSelected.emit(true)"
          >
            <fl-radio-card-body>
              <fl-text
                i18n="
                   Post Job Page form location question - local job option title

                "
                [size]="TextSize.SMALL"
                [weight]="FontWeight.BOLD"
              >
                Yes, local job
              </fl-text>
              <fl-text
                i18n="
                   Post Job Page form location question - local job option
                  description
                "
              >
                Freelancers must be in a specific location to bid on your
                project. Expect fewer, more specific bids.
              </fl-text>
            </fl-radio-card-body>
          </fl-radio-card>
        </fl-col>
      </fl-grid>
    </fl-bit>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectLocalQuestionComponent implements OnInit {
  TextSize = TextSize;
  FontWeight = FontWeight;
  HeadingType = HeadingType;
  Margin = Margin;
  VerticalAlignment = VerticalAlignment;

  @Input() control: FormControl;
  @Output() cardSelected: EventEmitter<boolean> = new EventEmitter();

  isLocalCardSelected$: Rx.Observable<boolean>;
  isOnlineCardSelected$: Rx.Observable<boolean>;

  ngOnInit() {
    this.isLocalCardSelected$ = this.control.valueChanges.pipe(
      startWith(this.control.value),
      filter(isDefined),
    );

    this.isOnlineCardSelected$ = this.isLocalCardSelected$.pipe(
      map(isLocal => !isLocal),
    );
  }
}
